import {
    Column,
    Entity,
    Index,
    ManyToMany,
    PrimaryGeneratedColumn,
} from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IInstallation } from './interface/IInstallation';
import { ITechnicalFile } from './interface/ITechnicalFile';

@Entity('technical_file')
export class TechnicalFile extends BaseEntity implements ITechnicalFile {
    apiMapping = {
        id: 'extId',
        title: 'title',
        reference: 'reference',
        version: 'version',
        numberOfPages: 'pages',
        author: 'author',
        date: 'date',
        refInstallationTechnicalFileTypeId:
            'refInstallationTechnicalFileTypeId',
    };

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: true })
    @Index()
    extId: number;

    @Column({ nullable: true })
    title: string;

    @Column({ nullable: true })
    reference: string;

    @Column({ nullable: true })
    version: string;

    @Column({ nullable: true })
    pages: number;

    @Column({ nullable: true })
    author: string;

    @Column({ nullable: true })
    refInstallationTechnicalFileTypeId: number;

    @Column({ nullable: true })
    date: string;

    @ManyToMany('Installation', 'technicalFile')
    installations: IInstallation[];
}
